import { SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import TranslateButton from '../components/translation/TranslateButton';
import { useBrowserOrAccountLocale } from '../hooks/useBrowserOrAccountLocale';
import { useShallowMergeSxProps } from '../hooks/useShallowMergeSxProps';
import { H, V } from '../Layout';
import { useStyling } from '../Theme';
import { toDisplay } from '../utils/dateTime';

const CONTAINER_BASE_SX = { mt: 1, gap: 0.5 };

type LexicalRendererFooterProps = {
    updatedOn: string;
    updatedByName: string;
    CustomFooterComponent?: React.ReactNode;
    typographySx?: SxProps;
    disableTranslation?: boolean;
    content?: string;
    onTranslated?: (translatedText: string) => void;
    sx?: SxProps<Theme>;
};

export default function LexicalRendererFooter(props: LexicalRendererFooterProps) {
    const {
        updatedOn,
        updatedByName,
        CustomFooterComponent,
        typographySx,
        disableTranslation = false,
        content,
        onTranslated,
        sx
    } = props;
    const { theme } = useStyling();
    const locale = useBrowserOrAccountLocale();
    const displayTranslateButton = !disableTranslation && content;
    const containerSx = useShallowMergeSxProps(CONTAINER_BASE_SX, sx);
    const updatedByNameSX = useShallowMergeSxProps({ flexGrow: 2 }, typographySx);
    return (
        <V sx={containerSx}>
            {CustomFooterComponent}
            <H gap={1}>
                <Typography
                    fontSize={theme.typography.pxToRem(10)}
                    fontWeight={theme.typography.fontWeightRegular}
                    color={theme.palette.text.disabled}
                    sx={typographySx}
                >
                    {toDisplay(updatedOn, false, locale)}
                </Typography>
                <Typography
                    fontSize={theme.typography.pxToRem(10)}
                    fontWeight={theme.typography.fontWeightRegular}
                    className={'ellipsis'}
                    sx={updatedByNameSX}
                    color={theme.palette.text.disabled}
                >
                    {updatedByName}
                </Typography>
                {displayTranslateButton && (
                    <TranslateButton text={content} format="html" onTranslated={onTranslated} sx={{ p: 0 }} />
                )}
            </H>
        </V>
    );
}
